import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from 'components/Modal';
import Button from 'components/Button';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import { truckersAPI } from 'services/apiRest';
import { actions as toastrActions } from 'react-redux-toastr';
import { useDispatch } from 'react-redux';

const ModalContainer = styled.div`
  padding: 20px;
  min-width: 600px;
  max-width: 800px;
`;

function ModalSelecionarVeiculo({ open, onClose, onSelect }) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [veiculos, setVeiculos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      buscarVeiculos();
    }
  }, [open]);

  const buscarVeiculos = async () => {
    try {
      setLoading(true);
      console.log('🔍 [ModalSelecionarVeiculo] Buscando motoristas...');
      // Buscar todos os motoristas para obter seus veículos
      const motoristas = await truckersAPI.listar();
      console.log('✅ [ModalSelecionarVeiculo] Motoristas encontrados:', motoristas.length);
      
      // Extrair todos os veículos de todos os motoristas
      const todosVeiculos = [];
      motoristas.forEach((motorista, index) => {
        console.log(`📋 [ModalSelecionarVeiculo] Motorista ${index + 1}:`, {
          nome: motorista.name || motorista.nome,
          cpf: motorista.cpf,
          veiculos: motorista.veiculos ? motorista.veiculos.length : 0
        });
        
        if (motorista.veiculos && Array.isArray(motorista.veiculos) && motorista.veiculos.length > 0) {
          motorista.veiculos.forEach(veiculo => {
            console.log('🚗 [ModalSelecionarVeiculo] Veículo encontrado:', {
              placa: veiculo.placa,
              tipo: veiculo.tipo,
              renavam: veiculo.renavam
            });
            todosVeiculos.push({
              ...veiculo,
              motorista_nome: motorista.name || motorista.nome || '',
              motorista_cpf: motorista.cpf || '',
              tipo: veiculo.tipo || 'tração' // tipo vem da relação truckers_veiculos
            });
          });
        }
      });
      
      console.log('✅ [ModalSelecionarVeiculo] Total de veículos encontrados:', todosVeiculos.length);
      setVeiculos(todosVeiculos);
    } catch (error) {
      console.error('❌ [ModalSelecionarVeiculo] Erro ao buscar veículos:', error);
      dispatch(toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: `Não foi possível carregar os veículos: ${error.message || 'Erro desconhecido'}`
      }));
    } finally {
      setLoading(false);
    }
  };

  const filteredVeiculos = veiculos.filter((veiculo) =>
    String(veiculo.placa || '').toUpperCase().includes(search.toUpperCase()) ||
    String(veiculo.renavam || '').toUpperCase().includes(search.toUpperCase()) ||
    String(veiculo.motorista_nome || '').toUpperCase().includes(search.toUpperCase())
  );

  const tableData = filteredVeiculos.map((veiculo) => ({
    id: veiculo.id || `${veiculo.placa}_${veiculo.motorista_cpf}`,
    placa: veiculo.placa || '-',
    renavam: veiculo.renavam || '-',
    uf: veiculo.uf_plate || veiculo.UF || veiculo.uf || '-',
    tipo: veiculo.tipo === 'tração' ? 'Tração' : 'Reboque',
    motorista: veiculo.motorista_nome || '-',
  }));

  const handleSelect = (veiculoId) => {
    const veiculo = filteredVeiculos.find((v) => 
      (v.id || `${v.placa}_${v.motorista_cpf}`) === veiculoId
    );
    if (veiculo && onSelect) {
      onSelect(veiculo);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Selecionar Veículo">
      <ModalContainer>
        <div style={{ marginBottom: '20px' }}>
          <SearchInput
            onChange={(e) => setSearch(e.target.value)}
            onClear={() => setSearch('')}
            value={search}
            placeholder="Buscar por placa ou RENAVAM..."
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              Carregando veículos...
            </div>
          ) : tableData.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
              Nenhum veículo encontrado. Cadastre veículos nos motoristas primeiro.
            </div>
          ) : (
            <Table
              columns={[
                { label: 'Placa', id: 'placa' },
                { label: 'RENAVAM', id: 'renavam' },
                { label: 'UF', id: 'uf' },
                { label: 'Tipo', id: 'tipo' },
                { label: 'Motorista', id: 'motorista' },
                { label: 'Ações', id: 'actions' },
              ]}
              data={tableData}
              customComponent={{
                actions: (e, item) => (
                  <Button
                    label="Selecionar"
                    onClick={() => handleSelect(item.id)}
                    color="primary"
                    width="100px"
                    height="30px"
                  />
                ),
              }}
            />
          )}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <Button
            label="Cancelar"
            onClick={onClose}
            color="secondary"
          />
        </div>
      </ModalContainer>
    </Modal>
  );
}

export default ModalSelecionarVeiculo;

